import React, { useState } from 'react'

const ImpactVideo = ({ src }) => {
  const [ loaded, setLoaded ] = useState(false)

  const handleCanPlay = e => {
    const target = e.target
    setTimeout(() => {
      if (target.currentTime)
        setLoaded(true)
    }, 250)
  }

  return (
    <div className="position-absolute overflow-hidden w-100 h-100">
      <video
        className="impact-video-bg"
        loop muted autoPlay playsInline
        onCanPlay={handleCanPlay}
        style={{ opacity: loaded ? 1 : 0 }}
      >
        <source src={src} type="video/mp4" />
      </video>
    </div>
  )
}

export default ImpactVideo
